import script from "./FundCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FundCard.vue?vue&type=script&setup=true&lang=js"

import "./FundCard.vue?vue&type=style&index=0&id=22693806&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22693806"]])

export default __exports__